import React from 'react';

import { FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

import { messages } from './messages';
import { AddressFactory } from '../../../../../address';
import { COUNTRY, EMAIL, NAME, PHONE } from '../../../../../address/constants';

const hiddenFields = [EMAIL, NAME, PHONE, COUNTRY];

/**
 * @typedef {import('../../../../../prop-types/address').AddressPropType} AddressPropType
 * @param {object} props
 * @param {AddressPropType} [props.address] - Invoice address
 * @param {Record<string, string>} [props.fieldsWithError] - List of fields that have any error
 * @param {(field: string, value: string) => void} props.onBlur - Callback to execute when onBlur is called
 * @param {(field: string, value: string) => void} props.onChange - Callback execute when address is changed
 * @param {string[]} [props.requiredFields]
 * @returns {JSX.Element}
 */
export const InvoiceAddress = ({ address = emptyObject, fieldsWithError, onBlur, requiredFields = emptyArray, onChange }) => (
  <FlexColumn gap={Gap.Space4}>
    <Text textType={TextType.H4} value={messages.header} />
    <AddressFactory
      address={address}
      hasError={fieldsWithError}
      hiddenFields={hiddenFields}
      isControlled
      onBlur={onBlur}
      onChange={onChange}
      requiredFields={requiredFields}
      showAddressLine3={false}
    />
  </FlexColumn>
);
